import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, DashboardModule, Text,
} from '@domain-group/suit-theme'

import useContract from '@hooks/useContract'
import useContracts from '@hooks/useContracts'

import ContractListItem from './ContractListItem'

const Contracts = (props) => {
  const { callbacks, ownerId, ownerType } = props

  const {
    filteredContracts,
    hasFilteredContracts,
    loading,
  } = useContracts({
    entityKey: ownerType + ownerId,
    filters: { owner_id: ownerId, owner_type: ownerType },
    performHttpRequests: !!ownerType && !!ownerId,
  })

  const { callbacks: { addContract } } = useContract({ owner_id: ownerId, owner_type: ownerType })

  return (
    <DashboardModule title="Contracts" loading={loading}>
      <Box flexDirection="column">
        <DashboardModule.ScrollableSection>
          {!loading && hasFilteredContracts && filteredContracts.map(contract => (
            <ContractListItem
              key={contract.id}
              callbacks={callbacks}
              contract={contract}
            />
          ))}
        </DashboardModule.ScrollableSection>

        <DashboardModule.Footer boxProps={{ borderTop: hasFilteredContracts ? '1px solid' : 'none' }}>
          {!loading && !hasFilteredContracts && (
            <Text
              color="bodyFontLightColor"
              display={['none', 'flex']}
              fontSize="small"
              variant="ellipsis"
              maxWidth="60%"
            >
              Contract Not Set
            </Text>
          )}

          <DashboardModule.FooterRight>
            <Button
              buttonStyle="secondaryEdit"
              icon={<FontAwesomeIcon icon={faPlus} />}
              onClick={() => addContract()}
              size={['medium', 'small']}
              width={['100%', 'fit-content']}
            >
              Add Contract
            </Button>
          </DashboardModule.FooterRight>
        </DashboardModule.Footer>
      </Box>
    </DashboardModule>
  )
}

Contracts.propTypes = {
  callbacks: PropTypes.shape({
    deleteContract: PropTypes.func.isRequired,
  }),
  ownerId: PropTypes.number.isRequired,
  ownerType: PropTypes.string.isRequired,
}

export default Contracts
